/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".submit-new-business__alert[_ngcontent-%COMP%]{color:red}p[_ngcontent-%COMP%]{line-height:1.2;padding-bottom:10px}"];
export { styles as styles };
